
export const DeliveryMethods = {
    MyPack: "MyPack",
    Porterbuddy: "Porterbuddy",
    HomeDelivery: "HomeDelivery",
    PickUpInStore: "PickUpInStore",
} as const;

export const AfterpayMethods = {
    Account: "account",
    Installment: "installment",
} as const;